import React, { FC } from 'react';

import { FormSectionWaitListProps } from './FormSectionWaitList.types';

const FormSectionWaitList: FC<FormSectionWaitListProps> = ({
  formData,
  register,
}) => {
  return (
    <div className='grid-container full'>
      <div className='grid-x form-group'>
        <div className='checkbox__container'>
          <label className='cta-section__label checkbox--label-inline checkbox'>
            <div className='checkbox__input-container'>
              <input
                className='checkbox__input'
                type='checkbox'
                id={formData.isWaitlisted.name}
                name={formData.isWaitlisted.name}
                {...register(formData.isWaitlisted.name)}
              />
              <div className='checkbox__faux-input' />
            </div>
          </label>
          <label
            htmlFor={formData.isWaitlisted.name}
            className='cta-section__label checkbox__label-text checkbox__label-text--inline-block'
            dangerouslySetInnerHTML={{
              __html: formData.isWaitlisted.label,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FormSectionWaitList;
